import { graphql } from 'react-relay';

export const userGeoInfoQuery = graphql`
    query userGeoInfoQuery($cookieDomain: String = "") {
        viewer {
            regionalInfo(cookieDomain: $cookieDomain) {
                countryCode
                zipCode
                regionsByZipCode {
                    urlLabel
                }
            }
        }
    }
`;
